import clsx from 'clsx'
import Image from 'next/image'
import { useState } from 'react'

/* blocks */
import Carousel from '../Carousel/Carousel'
import VideoModal from '@/atoms/Modal/VideoModal'

interface Props {
  title: string
  titleClass?: string
  bgImage?: StrapiImageFile
  lists: {
    title: string
    description: string
    image?: StrapiImageFile
    videoUrl: string
  }[]
}

function Portfolio({ title, titleClass, bgImage, lists }: Props) {
  const [showVideoModal, setShowVideoModal] = useState(false)
  const [videoLink, setVideoLink] = useState('')

  const handleVideoButtonClick = (url: string) => {
    setVideoLink(url)
    setShowVideoModal(true)
  }

  return (
    <section className={clsx(bgImage ? '' : 'bg-blue-web-90')}>
      <div className="relative">
        {bgImage ? (
          <Image
            src={bgImage.url}
            alt={bgImage.alternativeText ?? ''}
            height={bgImage.height}
            width={bgImage.width}
            className="absolute w-full h-full object-top"
          />
        ) : null}

        <div className="container | py-10 md:py-18 relative z-10">
          <h2
            className={clsx(
              titleClass ?? 'text-3xl lg:text-5xl font-semibold text-white'
            )}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
        <div className="md:pb-18">
          <Carousel
            navigationType="arrow"
            sliderClassName="mb-10 md:first:ml-10 px-4 md:px-0"
            slides={lists.map(list =>
              list.videoUrl ? (
                <button
                  key={list.title}
                  className="max-w-col-7"
                  onClick={() =>
                    handleVideoButtonClick(list.videoUrl.split('/embed/')[1])
                  }
                >
                  <div className="snap-center | relative">
                    <div className="flex flex-col | text-left rounded-xl">
                      <div className="relative">
                        <Image
                          src={list.image?.url ?? ''}
                          alt={list.image?.alternativeText ?? ''}
                          height={list.image?.height}
                          width={list.image?.width}
                          className="object-cover | rounded-2xl"
                        />
                      </div>
                      <div className="absolute text-white p-6">
                        {list.description ? (
                          <div
                            className="font-body text-sm md:text-base font-medium uppercase | line-clamp-2 | h-8"
                            dangerouslySetInnerHTML={{
                              __html: list.description
                            }}
                          />
                        ) : (
                          <div className="h-8 mb-8" />
                        )}
                        <h3
                          className="font-heading | text-2xl md:text-4xl font-semibold | mb-4"
                          dangerouslySetInnerHTML={{ __html: list.title }}
                        />
                      </div>
                    </div>
                  </div>
                </button>
              ) : (
                <div key={list.image?.url} className="snap-center | relative">
                  <div className="flex flex-col | text-left rounded-xl">
                    <div className="relative">
                      <Image
                        src={list.image?.url ?? ''}
                        alt={list.image?.alternativeText ?? ''}
                        height={list.image?.height}
                        width={list.image?.width}
                        className="object-cover | rounded-2xl"
                      />
                    </div>
                  </div>
                </div>
              )
            )}
          />
          {showVideoModal && (
            <VideoModal
              link={`https://www.youtube.com/embed/${videoLink}`}
              handleClose={() => setShowVideoModal(false)}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default Portfolio
